<template>    
    <v-card color="#fff" light>
        <v-card-title>            
            <h1 class="display-5">{{ item.street }}</h1> </br>                
        </v-card-title>                                        
        <v-container grid-list-xs fill-height>
            <v-layout row wrap fill-height>                
                <v-flex d-flex xs12>
                    <v-layout column>
                        
                        <v-flex>                           
                            PLZ: {{item.zip}}
                        </v-flex>
                        <v-flex>                           
                            Ort: {{item.city}}  
                        </v-flex>                           
                        <v-flex>
                            Land: {{ item.country }}
                        </v-flex>
                        <v-flex>
                            Breitengrad: {{ item.latitude }}
                        </v-flex>
                        <v-flex>
                            Längengrad: {{ item.longitude }}
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>

                        
        <v-card-actions class="grey darken-3 pt-0">
            
            <listactionbar v-on:actiontriggered="onAction" :item="item" :tileactions="tileactions"></listactionbar>
            
        </v-card-actions>  
                    
        
    </v-card>
</template>
<script>
    import listactionbar from './ListActionbar.vue'
    import { mapGetters } from 'vuex';    
    export default {   
    
    props: [
        'item',
        'tileactions',
        'paths'
    ],
    components: {
        listactionbar:listactionbar
    },
    data() {
        return {  
           
                    
        }
    },
    computed: {        
        
    },
    methods: {
        onAction(action){
            
                           
            if(action.link!=""){
                this.$router.push({name: action.link, params: {id: this.item.id}})
            } else {
                var r = confirm("remove image")
                if (r == true) {                
                    this.$store.dispatch('adresses/deleteById',this.item.id)
                            .then(response=>{
                                this.setMessage('200','Erfolg. Die Adresse wurde gelöscht')
                            }).catch(error=>{
                                this.setMessage(error.response.status,error.response.data)
                            })
                }else{                    
                }
            }
            
        }
    },
    
    
    
}
</script>
